ACC.autocomplete = {
  bindAll: function () {
    this.bindSearchAutocomplete();
  },

  bindSearchAutocomplete: function () {
    // extend the default autocomplete widget, to solve issue on multiple instances of the searchbox component
    $.widget('custom.yautocomplete', $.ui.autocomplete, {
      _create: function () {
        // get instance specific options form the html data attr
        var option = this.element.data('options');
        // set the options to the widget
        this._setOptions({
          minLength: option.minCharactersBeforeRequest,
          displayProductImages: option.displayProductImages,
          delay: option.waitTimeBeforeRequest,
          autocompleteUrl: option.autocompleteUrl,
          source: this.source,
        });

        // call the _super()
        $.ui.autocomplete.prototype._create.call(this);
      },
      options: {
        cache: {}, // init cache per instance
        focus: function () {
          return false;
        }, // prevent textfield value replacement on item focus
        select: function (event, ui) {
          window.location.href = ui.item.url;
        },
        position: {my: 'right top', at: 'right bottom', collision: 'none none'},
      },
      _renderItem: function (ul, item) {
        if (!ul.hasClass('search-autocomplete-container')) {
          ul.addClass('search-autocomplete-container');
        }

        $autocompleteArrow.css('display', 'block');

        if (item.type == 'autoSuggestion') {
          var renderHtml =
            "<a href='" +
            ACC.config.encodedContextPath +
            '/search?text=' +
            item.value +
            "' class='flow-root'>" +
            item.value +
            '</a>';
          return $("<li class='suggestions'>").data('item.autocomplete', item).append(renderHtml).appendTo(ul);
        }
        // only show categories on B2B
        else if (item.type == 'categoryResult' && ACC.isB2Bsite) {
          // check if the header exists and if not add one
          // aria-labels are needed on the header to avoid a console error when menufocus() looks for the aria-label attribute or item.value
          if (!ul.find('#categories-header').length) {
            $(
              "<li aria-label='categories-header' class='ui-menu-item header-list-item p-1'><span id='categories-header' class='text-xs text-left font-bold text-gray-80'>" +
                $('#categories-text').val() +
                '</span></li>'
            ).appendTo(ul);
          }
          var renderCategoryHtml =
            "<a href='" + ACC.config.encodedContextPath + item.url + "' class='category flow-root autocompletelink'>";
          renderCategoryHtml += "<span class='desc'>";
          renderCategoryHtml += "<span class='title'>" + item.value + '</span>';
          renderCategoryHtml += '</span>';
          renderCategoryHtml += '</a>';
          return $("<li class='text-left'>").data('item.autocomplete', item).append(renderCategoryHtml).appendTo(ul);
        } else if (item.type == 'productResult') {
          // add the product header once if on B2B
          // aria-labels are needed one the header to avoid a console error when menufocus() looks for the aria-label attribute or item.value
          if (!ul.find('#products-header').length && ACC.isB2Bsite) {
            $(
              "<li aria-label='products-header' class='ui-menu-item header-list-item p-1'><span id='products-header' class='text-xs text-left font-bold text-gray-80'>" +
                $('#products-text').val() +
                '</span></li>'
            ).appendTo(ul);
          }
          var renderProductHtml =
            "<a href='" + ACC.config.encodedContextPath + item.url + "' class='product flow-root autocompletelink'>";
          if (item.image != null && !ACC.isB2Bsite) {
            renderProductHtml += "<span class='thumb'><img src='" + item.image + "' /></span>";
          }
          renderProductHtml += `<span class='desc'>`;
          renderProductHtml += `<span class='title'>${item.value}${item?.year ? ' (' + item.year + ')' : ''}</span>`;
          renderProductHtml += "<span class='price'>" + item.price + '</span>';
          renderProductHtml += '</span>';
          renderProductHtml += '</a>';
          return $("<li class='product'>").data('item.autocomplete', item).append(renderProductHtml).appendTo(ul);
        }
      },
      source: function (request, response) {
        var self = this;
        var term = request.term.toLowerCase();
        if (term in self.options.cache) {
          return response(self.options.cache[term]);
        }

        $.getJSON(self.options.autocompleteUrl, {text: request.term}, function (data) {
          var autoSearchData = [];
          if (data.suggestions != null) {
            $.each(data.suggestions, function (i, obj) {
              autoSearchData.push({
                value: obj.term,
                url: ACC.config.encodedContextPath + '/search?text=' + obj.term,
                type: 'autoSuggestion',
              });
            });
          }

          if (data.categories != null) {
            $.each(data.categories, function (i, obj) {
              autoSearchData.push({
                value: obj.name,
                url: obj.url,
                type: 'categoryResult',
              });
            });
          }

          if (data.products != null) {
            $.each(data.products, function (i, obj) {
              autoSearchData.push({
                value: obj.name,
                code: obj.code,
                desc: obj.description,
                manufacturer: obj.manufacturer,
                year: obj.marketingModelYear,
                url: obj.url,
                price: obj.price != null ? obj.price.formattedValue : '',
                type: 'productResult',
                image: obj.images != null && self.options.displayProductImages ? obj.images[0].url : null, // prevent errors if obj.images = null
              });
            });
          }

          self.options.cache[term] = autoSearchData;
          return response(autoSearchData);
        });
      },
    });

    var $multiBrandHeaderSearch = $('.header-wrap--multibrand');
    var $search = $('.siteSearchInput');
    var $searchBox = $multiBrandHeaderSearch.find('.search-form-box');
    var $searchIcon = $searchBox.find('.search-form-icon');
    var $searchCloseIcon = $searchBox.find('.search_close');
    var $autocompleteArrow = $searchBox.find('.autocomplete-arrow');

    if ($search.length > 0) {
      $search.yautocomplete();
    }

    $search
      .on('focus', function () {
        $searchIcon.addClass('active-icon');
      })
      .on('input', function () {
        var inputLength = $(this).val().length;

        if (inputLength == 0) {
          $searchCloseIcon.css('display', 'none');
        } else {
          $searchCloseIcon.css('display', 'block');
        }

        if (inputLength < 2) {
          $autocompleteArrow.css('display', 'none');
        }
      })
      .on('blur', function () {
        $searchIcon.removeClass('active-icon');
        $autocompleteArrow.css('display', 'none');
      });

    $searchCloseIcon.on('click', function () {
      $search.val('');
      $searchCloseIcon.css('display', 'none');
    });
  },
};

$(window).on('load', function () {
  ACC.autocomplete.bindAll();
});
